import { findAction } from 'actions';
export function isPhoneRequired(user) {
    return user.accountRole === 'sales_agent';
}
/**
 * Profile setup is required when the backend hasn't recorded a name for this user yet
 * (`subject.principal.user[0].name` is falsy → surfaced as `user.name === ''`) AND the root
 * `myProfile` action is advertised. If the action is missing we silently skip the gate
 * (per Jira: "if for some reason it's not, don't show the form").
 */
export function needsProfileSetup(user) {
    if (user.name)
        return false;
    return Boolean(findAction(user, 'myProfile'));
}
